import { createContext, useContext } from "react";
import { brandPreview } from "./brandPreview";

/** SSR supplies a controller per request; the browser uses its one page store. */
export const WebsiteBrandContext = createContext(brandPreview);
export const useWebsiteBrand = () => useContext(WebsiteBrandContext);
